import { useContext } from "react"

//Context
import { AssessmentFormulaBuilderContext } from "../../../../../../context/assessmentFormulaBuilderContext"

//PrimeReact
import { Button } from "primereact/button"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css" //Styles
import assessStyles from "../../../../../../styles/assessments/Assessment.module.css"

export default function RenderFormulaButtons({ disabled, formulaOrderid }) {
  const { onDeleteFormulaOrder } = useContext(AssessmentFormulaBuilderContext)

  return (
    <div className={myStyles.formulaRenderLayoutControl}>
      <Button
        className={assessStyles.actionButton}
        type="button"
        tooltip="Delete"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => {
          onDeleteFormulaOrder(formulaOrderid)
        }}
        disabled={disabled}
      >
        <span className={`material-icons`}>{"delete"}</span>
      </Button>
    </div>
  )
}
